import { jwtDecode } from 'jwt-decode';
import React, { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'

const Dashboard = () => {
    const navigate = useNavigate();
    const handleLogout = () => {
        localStorage.removeItem('localuser');
        localStorage.removeItem('Authorization');
        localStorage.removeItem('MemberId');
        localStorage.removeItem('MemberCode');
        localStorage.removeItem('lastAuthTimeMillis');
        localStorage.removeItem('isAdminLogin');
        navigate('/admin/login');
    };

    return (
        <>
            <div className="dashboard-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "20px" }}>
                <h1 className="h1header">Dashboard</h1>
                <button className="logout-btn" onClick={handleLogout}>Logout</button>
            </div>
            <div className="linkContainer">
                <Link className="header__link" to="/admin/basePrice">
                    GET BASE PRICE TABLE
                </Link>
                <Link className="header__link" to="/admin/slotPrice">
                    GET SLOT PRICE TABLE
                </Link>
                <Link className="header__link" to="/admin/notification">
                    NOTIFICATION
                </Link>
                <Link className="header__link" to="/admin/cricket-calender">
                    CRICKET CALENDER
                </Link>
                <Link className="header__link" to="/admin/pickle-ball-calender">
                    PICKLE BALL CALENDER
                </Link>
                <Link className="header__link" to="/admin/slotBooking">
                    BOOK SLOT
                </Link>
                <Link className="header__link" to="/admin/notification-history">
                    Notification History
                </Link>
                <Link className="header__link" to="/admin/events">
                    Events
                </Link>
                <Link className="header__link" to="/admin/club-magazine">
                    Magazines
                </Link>
                <Link className="header__link" to="/admin/activity">
                    Activity Logs
                </Link>
                <Link className="header__link" to="/admin/contact-us">
                    Contact Us
                </Link>
                <Link className="header__link" to="/admin/receipt-list">
                    RECEIPT LIST
                </Link>
            </div>
        </>
    )
}

export default Dashboard
